<template>
  <div class="calculation-assembly-items">
    <!-- Seznam dílců -->
    <div v-for="item in props.calculationItems" :key="item.id" class="item-row"
         :class="(item.assemblyItems && item.assemblyItems.length > 0) ? 'selected' : ''">
      <div class="d-flex justify-content-start align-items-center">
        <span class="d-inline-block"
              tabindex="0"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-delay="0"
              title="Editace montážních prací">
          <button class="btn btn-sm btn-outline-secondary" @click="openAssemblyModal(item)">
            <i class="bi bi-pencil-fill"></i>
          </button>
        </span>
        <div class="mx-3">
          <div><b>{{ item.name }}</b></div>
          <div class="text-muted small">
            {{ item.itemOrigin.price_list_item.name }},
            {{ item.thickness }},
            {{ item.surface }},
            {{ item.itemOrigin.shape.name }},
            {{ item.area }} m²,
            {{ item.weight }} kg
          </div>
        </div>
      </div>
      <div v-if="item.assemblyItems && item.assemblyItems.length > 0" class="operations-section">
        <h6>Montážní práce:</h6>
        <div v-for="assemblyItem in item.assemblyItems" :key="assemblyItem.id" class="assembly-item mb-2">
          <div class="d-flex justify-content-between align-items-center">
                <span>
                  {{ getOperationName(assemblyItem.id) }}
                </span>
            <button class="btn btn-sm btn-outline-danger"
                    @click="removeAssemblyItem(item, assemblyItem.id)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-else class="operations-section text-muted">
        Žádné montážní práce
      </div>
    </div>

    <!-- Modální okno pro výběr montážních úkonů -->
    <div class="modal fade" id="assemblyModal" tabindex="-1" ref="assemblyModalRef">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Montážní úkony - {{ currentItem?.name }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

          </div>
          <div class="modal-body">
            <!-- Sekce: Spojovací materiál -->
            <div v-if="assemblyOperations && assemblyOperations.length > 0" class="mb-4">
              <h6 class="mb-3 text-primary">Spojovací materiál</h6>
              <div v-for="operation in assemblyOperations" :key="operation.id" class="form-check my-1">
                <div>
                  <input class="form-check-input" type="checkbox"
                         :id="`assembly-operation-${operation.id}`"
                         :checked="isOperationSelected(operation.id)"
                         @change="toggleOperation(operation, $event.target.checked)">
                  <label class="form-check-label" :for="`assembly-operation-${operation.id}`">
                    {{ operation.name }}
                  </label>
                </div>
                <SidesSelector
                    v-if="operation.related_to === 'side' && currentItem && isOperationSelected(operation.id)"
                    :key="`${operation.id}-${modalResetKey}`"
                    :sides="currentItem.dimensions"
                    :init-selected-sides="getSelectedSideValue(operation)"
                    @selected-sides="(sides) => updateSelectedSides(operation, sides)"
                    />
              </div>
            </div>

            <!-- Sekce: Montáž prvků do pracovní desky -->
            <div v-if="assemblyActionOperations && assemblyActionOperations.length > 0">
              <h6 class="mb-3 text-primary">Montáž prvků do pracovní desky</h6>
              <div v-for="operation in assemblyActionOperations" :key="operation.id" class="form-check my-1">
                <input class="form-check-input" type="checkbox"
                       :id="`assembly-action-operation-${operation.id}`"
                       :checked="isOperationSelected(operation.id)"
                       @change="toggleOperation(operation, $event.target.checked)">
                <label class="form-check-label" :for="`assembly-action-operation-${operation.id}`">
                  <span v-if="!isOperationRecommended(operation)" class="text-black"> {{ operation.name }}</span>
                  <span v-if="isOperationRecommended(operation)" class="text-success fw-bold"> {{ operation.name }}</span>
                  <span v-if="isOperationRecommended(operation)" class="badge bg-success mx-2">D</span>
                </label>
              </div>
            </div>

            <!-- Pokud nejsou k dispozici žádné operace -->
            <div v-if="!availableOperations || availableOperations.length === 0" class="text-muted">
              Nejsou k dispozici žádné montážní práce.
            </div>

<!--
            <div v-for="operation in assemblyOperations" :key="operation.id" class="operation-item mb-3">
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    :id="`operation-${operation.id}`"
                    :checked="isOperationSelected(operation.id)"
                    @change="toggleOperation(operation, $event.target.checked)"
                />
                <label class="form-check-label" :for="`operation-${operation.id}`">
                  {{ operation.name }}
                </label>
              </div>

              <!-– Výběr stran pro úkon ––>
              <div
                  v-if="isOperationSelected(operation.id) && operation.requires_sides"
                  class="sides-selection mt-2 ms-4"
              >
                <label class="form-label">Výběr stran:</label>
                <div class="row">
                  <div v-for="side in availableSides" :key="side.key" class="col-md-6 mb-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-text">{{ side.label }}</span>
                      <input
                          type="number"
                          class="form-control"
                          :value="getSelectedSideValue(operation.id, side.key)"
                          @input="updateSideValue(operation.id, side.key, $event.target.value)"
                          step="0.01"
                          min="0"
                          placeholder="Rozměr"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
-->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Zrušit
            </button>
            <button type="button" class="btn btn-primary" @click="saveAssemblyItems">
              Uložit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted, defineProps, defineEmits, watch, computed, nextTick} from 'vue'
import {Modal} from 'bootstrap'
import myApi from "@/api/api";
import SidesSelector from "@/components/calculation/SidesSelector.vue";

// Props
const props = defineProps({
  calculationItems: {
    type: Array,
    required: true
  }
})

// Emits
const emit = defineEmits(['assembly-items-updated', 'update:max-weight-item'])

// Reactive data
const assemblyModalRef = ref(null)
const currentItem = ref(null)
const selectedOperations = reactive(new Map())
const modalInstance = ref(null)
const availableOperations = ref(null)
const modalResetKey = ref(0) // Klíč pro vynucení rerenderu SidesSelector

// Computed property pro maxWeightItem
const maxWeightItem = computed(() => {
  const weights = props.calculationItems
    .filter(obj => obj?.assemblyItems && obj.assemblyItems.length > 0)
    .map(obj => obj.weight)
  return weights.length > 0 ? Math.max(...weights) : 0
})

// Funkce pro emit maxWeightItem
const emitMaxWeightItem = () => {
  const maxWeight = maxWeightItem.value
  emit('update:max-weight-item', maxWeight)
}

// Funkce pro reset stavu modálu
const resetModalState = () => {
  currentItem.value = null
  selectedOperations.clear()
  modalResetKey.value++ // Zvýšením klíče vynucujeme rerender SidesSelector
}

// Lifecycle
onMounted(async () => {
  modalInstance.value = new Modal(assemblyModalRef.value)
  
  // Přidání event listeneru pro Bootstrap modal událost
  assemblyModalRef.value.addEventListener('hidden.bs.modal', resetModalState)
  
  availableOperations.value = await myApi.listPriceListIndividualItems([], [])
  
  // Emit maxWeightItem při inicializaci
  await nextTick()
  emitMaxWeightItem()
})

// Watch pro změny maxWeightItem
watch(maxWeightItem, (newValue) => {
  emit('update:max-weight-item', newValue)
})

// Watch pro změny v calculationItems (pokud se data načítají asynchronně)
watch(() => props.calculationItems, () => {
  nextTick(() => {
    emitMaxWeightItem()
  })
}, { deep: true, immediate: true })

// Methods
const openAssemblyModal = (item) => {
  currentItem.value = item
  loadCurrentAssemblyItems()
  modalInstance.value.show()
}

// Computed properties pro filtrování operací podle typu
const assemblyOperations = computed(() => {
  if (availableOperations.value && Array.isArray(availableOperations.value)) {
      return availableOperations.value.filter(operation => operation.type === 'assembly')
  } 
  return []
})

const assemblyActionOperations = computed(() => {
  if (availableOperations.value && Array.isArray(availableOperations.value)) {
    return availableOperations.value.filter(operation => operation.type === 'assembly_action')
  } 
  return []
})

// Funkce pro určení, zda je operace doporučená
const isOperationRecommended = (operation) => {
  if (!currentItem.value || !currentItem.value?.assemblyItems || !operation?.action_references) {
    return false
  }

  for (const [actionId, actionParams] of Object.entries(currentItem.value.actions)) {
    if (actionParams && actionParams.action_origin && actionId) {
      // Porovnáme action_origin s action_reference.id
      const actionReferenceIds = operation.action_references.map(ref => ref.id)
      if (actionReferenceIds.includes(actionParams.action_origin)) {
        return true
      }
    }
  }

  return false
}

const getSelectedSideValue = (operation) => {
  if (!currentItem.value || !currentItem.value?.assemblyItems) {
    return {}
  }
  const operationData = currentItem.value.assemblyItems.find(ai => ai.id === operation.id)
  return operationData?.sides || {}
}

const loadCurrentAssemblyItems = () => {
  // Načtení aktuálních montážních úkonů do selectedOperations
  selectedOperations.clear()

  if (currentItem.value.assemblyItems) {
    currentItem.value.assemblyItems.forEach(assemblyItem => {
      selectedOperations.set(assemblyItem.id, {
        id: assemblyItem.id,
        originItem: assemblyItem.originItem || null,
        sides: assemblyItem.sides || null
      })
    })
  }
}

const isOperationSelected = (operationId) => {
  return selectedOperations.has(operationId)
}

const toggleOperation = (operation, isSelected) => {
  let unitCount = 1
  if (operation.related_to === 'surface') {
    unitCount = currentItem.value.area
  }

  if (operation.related_to === 'piece') {
    const itemActions = Object.values(currentItem.value.actions)
    // pokud se jedná o doporučenou montáz
    // počet jednotek bere z actions u dílce se kterou je montáž svázána
    if (operation.action_references) {
      let recommendedAction = itemActions.find(action => operation.action_references.map(ref => ref.id).includes(action.action_origin))
      if (recommendedAction) {
        unitCount = recommendedAction.unit_count
      }
    }
  }
  if (isSelected) {
    // Přidání operace
    const operationData = {
      id: operation.id,
      originItem: null,
      sides: operation.related_to === 'side' ? {} : null,
      unitCount: unitCount,
    }
    selectedOperations.set(operation.id, operationData)
  } else {
    // Odebrání operace
    selectedOperations.delete(operation.id)
  }
}

const updateSelectedSides = (operation, sides) => {
  const unitCount = Object.values(sides).reduce((acc, val) => acc + val, 0)
  selectedOperations.get(operation.id).sides = sides
  selectedOperations.get(operation.id).unitCount = (unitCount / 1000)
}

const saveAssemblyItems = () => {
  // Převod selectedOperations na formát assemblyItems
  const assemblyItems = Array.from(selectedOperations.values()).map(operation => ({
    id: operation.id,
    originItem: operation.originItem,
    sides: operation.sides && Object.keys(operation.sides).length > 0 ? operation.sides : null,
    unitCount: operation.unitCount ? operation.unitCount : 1,
  }))

  // Aktualizace assemblyItems u aktuálního dílce
  currentItem.value.assemblyItems = assemblyItems

  // Emitování události pro parent komponentu
  emit('assembly-items-updated', {
    itemId: currentItem.value.id,
    assemblyItems: assemblyItems
  })
  modalInstance.value.hide()
}

const removeAssemblyItem = (item, operationId) => {
  item.assemblyItems = item.assemblyItems.filter(ai => ai.id !== operationId)

  emit('assembly-items-updated', {
    itemId: item.id,
    assemblyItems: item.assemblyItems
  })
}

const getOperationName = (operationId) => {
  let operation = null
  if (availableOperations.value) {
    operation = availableOperations.value.find(op => op.id === operationId)
  }
  return operation ? operation.name : `Úkon ${operationId}`
}
</script>

<style scoped>

.item-row {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
}

.item-row.selected {
  border: 1px solid var(--bs-green);
}

.operations-section {
  margin-top: 1rem;
  padding-left: 1rem;
}

.assembly-item {
  padding-left: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
  border-left: 4px solid #a0a0a0;
}

.operation-item {
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
}

.operation-item:last-child {
  border-bottom: none;
}

.sides-selection {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.25rem;
}
</style>